function productDescriptionAnchor() {
	const anchor = document.getElementById('productDescriptionAnchor');

	if (anchor) {
		anchor.addEventListener('click', anchorToSection);
	}
}

function anchorToSection(event) {
	event.preventDefault();

	const targetId = event.target.hash.substring(1);
	const targetSection = document.getElementById(targetId);

	if (targetSection) {
		const productHeader = document.getElementById('productHeader');
		const offsetHeight = productHeader ? productHeader.offsetHeight : 0;
		const scrollY = targetSection.offsetTop - offsetHeight;

		window.scrollTo({
			top: scrollY,
			behavior: 'smooth',
		});

		const sku = event.target.getAttribute('data-product-sku');

		window.od.events.publish('productDescription_Click', {
			url: window.location.href,
			sku,
		});
	}
}

export default productDescriptionAnchor;
